import { useTranslation } from 'react-i18next';

import { displayMoney } from 'helpers/formatter';
import {
  isWeightPricedProduct,
  getListPrimaryPrice,
  getListStrikePrice,
} from 'helpers/product';

/** Цена в карточке: не весовой — «за уп.»; весовой — за 1 кг. */
const ProductPriceRow = ({
  item,
  priceClassName = 'popular-product-price',
  priceStyle = {},
}) => {
  const { t } = useTranslation();
  const weightPriced = isWeightPricedProduct(item);
  const primary = getListPrimaryPrice(item);
  const strike = getListStrikePrice(item);

  return (
    <div className='popular-product-price-row'>
      <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'baseline', gap: '8px' }}>
        {strike ? (
          <span
            className='popular-product-price-old'
            style={{ textDecoration: 'line-through', opacity: 0.65, fontSize: '14px' }}
          >
            {displayMoney(strike)}
          </span>
        ) : null}
        <span className={priceClassName} style={priceStyle}>
          {displayMoney(primary)}
        </span>
        <span className='popular-product-weight' style={{ color: '#888', fontSize: 13 }}>
          {weightPriced ? t('product.perKg') : t('product.perPiece')}
        </span>
      </div>
    </div>
  );
};

export default ProductPriceRow;
